<template>
  <v-form v-model="valid" ref="mainForm">
    <CarteIdentification :identification="identification" class="mb-6" />
    <CatalogueLive code="sexe" v-model="sasContact.sexe" :live="liveSasContact(5705)" />

    <CatalogueLive code="autres_noms_ouinon" :live="liveSasContact(5706)" v-model="sasContact.avezVousDejaUtiliseDAutresNoms" />
    <TextFieldLive
      code="autres_noms_lesquels"
      v-model="sasContact.anciensNoms"
      :live="liveSasContact(5707)"
      :opq-if="estOui(sasContact.avezVousDejaUtiliseDAutresNoms)"
    />
    <DatePickerLive
      code="autres_noms_date"
      v-model="sasContact.dateModificationNom"
      :live="liveSasContact(5708)"
      :opq-if="estOui(sasContact.avezVousDejaUtiliseDAutresNoms)"
      :maxValue="serverDate()"
    />
    <FileInput
      code="autres_noms_preuve"
      :file="sasContact.preuveChangementDeNom"
      :live="liveSasContact(5709)"
      :opq-if="estOui(sasContact.avezVousDejaUtiliseDAutresNoms)"
      @file-deleted="sasContact.preuveChangementDeNom = null"
    />
    <DatePickerLive
      code="date_inscription"
      v-model="sasInscriptionTableau.dateDInscriptionSouhaitee"
      :live="{ endpoint: 'sas-inscription-tableau', cle: 7702, fileId: sasInscriptionTableau.id }"
      :minValue="serverDateBefore22h00()"
      @eudo-updated="updatePanier"
    />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import SasContact from "@/mixins/SasContact"
import CarteIdentification from "@/components/form_parts/CarteIdentification.vue"
import { mapActions } from "vuex"

export default {
  components: { CarteIdentification },
  mixins: [CataloguesHelpers, DatesHelpers, StepFormWithValidation, SasContact],
  props: {
    sas: { type: Object }
  },
  computed: {
    identification() {
      return this.sas.identification
    },
    sasInscriptionTableau() {
      return this.sas.sasInscriptionTableau
    }
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    updatePanier() {
      this.fetchPanier({ endpoint: "demande-permis-inscription-tableau", sasId: this.sas.id })
    }
  }
}
</script>

<style></style>
